module.exports = __webpack_public_path__ + "static/media/1016781.d316e5b2.jpg";